import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export const ApplicationMain = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => setLoading(false), 500);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white pt-20">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-12 text-center">
            <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="text-green-600" size={48} />
            </div>
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Thank You for Submitting!
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Your application has been received successfully.
            </p>
            
            {customerId && (
              <div className="bg-blue-50 rounded-xl p-6 mb-8">
                <p className="text-sm text-gray-600 mb-2">Your Customer ID</p>
                <p className="text-3xl font-bold text-blue-600">{customerId}</p>
              </div>
            )}
            
            <div className="space-y-4 text-left bg-gray-50 rounded-xl p-6">
              <h2 className="text-xl font-bold text-gray-900">What's Next?</h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>Our team will review your application within 24 hours</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>You'll receive a confirmation email with next steps</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>One of our trademark specialists will contact you shortly</span>
                </li>
              </ul>
            </div>
            
            <div className="mt-8 text-gray-600">
              <p>Need immediate assistance?</p>
              <p className="mt-2">
                <a href="tel:+18446270636" className="text-blue-600 hover:text-blue-700 font-semibold">
                  Call us at +1 (844) 627-0636
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
